//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import tidalAccordion from '@tidal/styles-accordion/src/components/tidal-accordion.vue';
import headerLink from './tidal-header-link.vue';
import headerUser from './tidal-header-user.vue';

const FALLBACK_TRANSLATIONS = {
    featured: 'Featured',
    culture: 'Culture',
    magazineText: 'Magazine',
    about: 'About',
    loginText: 'Login',
    logoutText: 'Log Out',
    manageAccountText: 'Manage Account',
    myAccountText: 'My Account',
    startFreeTrialText: 'Start Free Trial',
    startFreeTrialShortText: '',
    skipToMain: 'Skip to main content',
    skipToFooter: 'Skip to footer',
    whatIsTidal: 'What is TIDAL?',
    exploreApp: 'Explore the App',
    pricingPlans: 'Pricing & Plans',
    download: 'Download TIDAL',
    playlistImport: 'Import Playlists',
    supportedDevices: 'Supported Devices',
    support: 'Support',
    getHelp: 'Get Help',
    webPlayer: 'Web Player',
    openApp: 'Open app',
    forMusic: 'For Music',
    forArtists: 'For Artists',
};

export default {
    components: {
        tidalAccordion,
        headerLink,
        headerUser,
    },
    /** @return {{ baseUrl: string, tidalUrl?: string }} */
    provide() {
        return {
            baseUrl: this.baseUrl,
            tidalUrl: this.tidalUrl,
        };
    },
    props: {
        login: {
            type: Boolean,
            default: true,
        },
        cta: {
            type: Boolean,
            default: true,
        },
        /** @type {import('vue').PropOptions<import('@tidal/styles-header').NavigationLink[] | boolean>} */
        links: {
            type: [Boolean, Array],
            default: false,
        },
        nuxtLinks: {
            type: Array,
            default: () => [],
        },
        sticky: {
            type: Boolean,
            default: false,
        },
        transparent: {
            type: Boolean,
            default: false,
        },
        disableClickableLogo: {
            type: Boolean,
            default: false,
        },
        disableTidalLogo: {
            type: Boolean,
            default: false,
        },
        disableAbsolutePosition: {
            type: Boolean,
            default: false,
        },
        /**
         * @property {string} name
         * @property {string} [image]
         * @type {import('vue').PropOptions<import('@tidal/styles-header').User>}
         */
        user: {
            type: Object,
            default: null,
        },
        logoutFunc: {
            type: Function,
            default: null,
        },
        loginFunc: {
            type: Function,
            default: null,
        },
        logoutUrl: {
            type: String,
            default: null,
        },
        loginUrl: {
            type: String,
            default: null,
        },
        signupUrl: {
            type: String,
            default: null,
        },
        baseUrl: {
            type: String,
            default: '/',
        },
        tidalUrl: {
            type: String,
            default: null,
        },
        manageAccountUrl: {
            type: String,
            default: 'https://my.tidal.com/account',
        },
        active: {
            type: String,
            default: null,
        },
        playerUrl: {
            type: String,
            default: 'https://listen.tidal.com/login?autoredirect=true',
        },
        /**
         * @property {string} [translations[].featured]
         * @property {string} [translations[].culture]
         * @property {string} [translations[].magazineText]
         * @property {string} [translations[].about]
         * @property {string} [translations[].loginText]
         * @property {string} [translations[].logoutText]
         * @property {string} [translations[].manageAccountText]
         * @property {string} [translations[].myAccountText]
         * @property {string} [translations[].startFreeTrialText]
         * @property {string} [translations[].startFreeTrialShortText]
         * @property {string} [translations[].skipToMain]
         * @property {string} [translations[].skipToFooter]
         * @property {string} [translations[].whatIsTidal]
         * @property {string} [translations[].exploreApp]
         * @property {string} [translations[].pricingPlans]
         * @property {string} [translations[].download]
         * @property {string} [translations[].playlistImport]
         * @property {string} [translations[].supportedDevices]
         * @property {string} [translations[].support]
         * @property {string} [translations[].getHelp]
         * @property {string} [translations[].webPlayer]
         * @property {string} [translations[].openApp]
         * @property {string} [translations[].forMusic]
         * @property {string} [translations[].forArtists]
         * @type {import('vue').PropOptions<Record<keyof FALLBACK_TRANSLATIONS, string>>}
         */
        translations: {
            type: Object,
            default: null,
        },
        translationFn: {
            type: Function,
            default: null,
        },
    },
    data() {
        return {
            showMainMenu: false,
            mainContent: false,
            footerContent: false,
            scrollPos: 0,
            // Resets subnav on click
            subclick: 0,
            subActive: '',
            /** @type {NodeJS.Timer?} */
            debounceTimeout: null,
        };
    },
    computed: {
        /** @return {import('@tidal/styles-header').CurrentUser | undefined} */
        currentUser() {
            if (this.user) {
                return {
                    name: this.user.firstName || this.user.fullName || this.user.userName,
                    image: this.user.imageId ? this.user.imageId.replace(/-/g, '/') : undefined,
                };
            }

            return undefined;
        },
        /** @return {boolean} */
        hasMenu() {
            return this.links === true || this.links && this.links.constructor === Array;
        },
        /** @return {boolean} */
        homeNuxt() {
            return this.nuxtLinks.includes('home');
        },
        /** @return {import('@tidal/styles-header').NavigationLink[]} */
        navigation() {
            return Array.isArray(this.links) ? this.links : [
                {
                    name: this.getTranslation('about'),
                    url: '',
                    isNuxt: false,
                    subnav: [
                        {
                            name: this.getTranslation('whatIsTidal'),
                            url: 'about',
                            isNuxt: this.nuxtLinks.includes('about'),
                        },
                        {
                            name: this.getTranslation('exploreApp'),
                            url: 'explore-the-app',
                            isNuxt: this.nuxtLinks.includes('explore-the-app'),
                        },
                        {
                            name: this.getTranslation('forMusic'),
                            url: 'formusic',
                            isNuxt: this.nuxtLinks.includes('formusic'),
                        },
                        {
                            name: this.getTranslation('forArtists'),
                            url: 'forartists',
                            isNuxt: this.nuxtLinks.includes('forartists'),
                        },
                        {
                            name: this.getTranslation('featured'),
                            url: 'featured',
                            isNuxt: this.nuxtLinks.includes('featured'),
                        },
                        {
                            name: this.getTranslation('culture'),
                            url: 'culture',
                            isNuxt: this.nuxtLinks.includes('culture'),
                        },
                        {
                            name: this.getTranslation('magazineText'),
                            url: 'magazine',
                            isNuxt: this.nuxtLinks.includes('magazine'),
                        },
                        {
                            name: this.getTranslation('pricingPlans'),
                            url: 'pricing',
                            isNuxt: this.nuxtLinks.includes('pricing'),
                        },
                    ],
                },
                {
                    name: this.getTranslation('support'),
                    url: '',
                    isNuxt: false,
                    subnav: [
                        {
                            name: this.getTranslation('download'),
                            url: 'download',
                            isNuxt: this.nuxtLinks.includes('download'),
                        },
                        {
                            name: this.getTranslation('playlistImport'),
                            url: 'import-playlist',
                            isNuxt: this.nuxtLinks.includes('import-playlist'),
                        },
                        {
                            name: this.getTranslation('supportedDevices'),
                            url: 'supported-devices',
                            isNuxt: this.nuxtLinks.includes('supported-devices'),
                        },
                        {
                            name: this.getTranslation('getHelp'),
                            url: 'help',
                            isNuxt: this.nuxtLinks.includes('help'),
                        },
                    ],
                },
            ];
        },
        /** @return {boolean} */
        loginNuxt() {
            return this.nuxtLinks.includes('login');
        },
        /** @return {boolean} */
        loginExternal() {
            return this.loginUrl.startsWith('http');
        },
        /** @return {string} */
        _signupUrl() {
            return this.signupUrl || 'try-now';
        },
        /** @return {boolean} */
        signupNuxt() {
            return this.nuxtLinks.includes('try-now');
        },
        /** @return {boolean} */
        myAccountNuxt() {
            return this.nuxtLinks.includes('manage-account');
        },
        /** @return {boolean} */
        myAccountExternal() {
            return this.manageAccountUrl.startsWith('http');
        },
        /** @return {string | null} */
        startFreeTrialShortText() {
            const shortText = this.getTranslation('startFreeTrialShortText');
            if (shortText && shortText !== this.getTranslation('startFreeTrialText')) {
                return shortText;
            }
            return null;
        },
        fallbackTranslations() {
            return FALLBACK_TRANSLATIONS;
        },
        playerUrlMobile() {
            return 'https://app.adjust.com/9elzdjp?engagement_type=fallback_click&deep_link=' + encodeURIComponent('tidal://');
        },
        /** @return {Array<string>} */
        wrapperClass() {
            return [
                (this.sticky ? (this.transparent ? 'is-sticky--fixed' : 'is-sticky') : ''),
                (this.showMainMenu ? (this.transparent ? 'is-open--fixed' : 'is-open') : ''),
            ];
        },
        /** @return {Record<string, boolean>} */
        headerClass() {
            return {
                'theme-transparent gradient-top': this.transparent,
                'position-absolute position-top position-stretch': this.transparent && !this.disableAbsolutePosition,
                'is-open': this.showMainMenu,
            };
        },
        loginIcon() {
            return '<svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.99982 2.00876C8.11717 2.00876 6.34982 3.86753 6.34982 6.48376C6.34982 9.09999 8.11717 10.9588 9.99982 10.9588C11.8825 10.9588 13.6498 9.09999 13.6498 6.48376C13.6498 3.86753 11.8825 2.00876 9.99982 2.00876ZM4.57482 6.48376C4.57482 3.17674 6.87048 0.233765 9.99982 0.233765C13.1292 0.233765 15.4248 3.17674 15.4248 6.48376C15.4248 9.79079 13.1292 12.7338 9.99982 12.7338C6.87048 12.7338 4.57482 9.79079 4.57482 6.48376ZM4.86864 11.6946C5.18024 12.0729 5.12611 12.6323 4.74775 12.9439C3.4899 13.9797 2.62172 15.3686 2.33358 16.9173C2.24393 17.3992 1.78061 17.7172 1.29872 17.6275C0.81684 17.5379 0.498874 17.0746 0.588527 16.5927C0.960387 14.5939 2.07221 12.8478 3.61936 11.5737C3.99773 11.2621 4.55705 11.3162 4.86864 11.6946ZM16.4215 11.5737C16.0431 11.2621 15.4838 11.3162 15.1722 11.6946C14.8606 12.0729 14.9147 12.6323 15.2931 12.9439C16.5522 13.9807 17.4129 15.3641 17.6626 16.8976C17.7413 17.3814 18.1974 17.7097 18.6811 17.631C19.1649 17.5522 19.4933 17.0962 19.4145 16.6124C19.0866 14.5984 17.9674 12.8468 16.4215 11.5737Z" fill="currentColor" /></svg>';
        },
        logoutIcon() {
            return '<svg width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M13 12C12.4523 12 12 12.4523 12 13V28C12 28.5477 12.4523 29 13 29H24C24.5477 29 25 28.5477 25 28V27.5C25 26.9477 25.4477 26.5 26 26.5C26.5523 26.5 27 26.9477 27 27.5V28C27 29.6523 25.6523 31 24 31H13C11.3477 31 10 29.6523 10 28V13C10 11.3477 11.3477 10 13 10H24C25.6523 10 27 11.3477 27 13V13.5C27 14.0523 26.5523 14.5 26 14.5C25.4477 14.5 25 14.0523 25 13.5V13C25 12.4523 24.5477 12 24 12H13ZM26.7071 16.7929L29.7071 19.7929C30.0976 20.1834 30.0976 20.8166 29.7071 21.2071L26.7071 24.2071C26.3166 24.5976 25.6834 24.5976 25.2929 24.2071C24.9024 23.8166 24.9024 23.1834 25.2929 22.7929L26.5858 21.5H18C17.4477 21.5 17 21.0523 17 20.5C17 19.9477 17.4477 19.5 18 19.5H26.5858L25.2929 18.2071C24.9024 17.8166 24.9024 17.1834 25.2929 16.7929C25.6834 16.4024 26.3166 16.4024 26.7071 16.7929Z" fill="currentColor" /></svg>';
        },
        arrowIcon() {
            return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 14.6L18.3 8.3 19.7 9.7 12 17.4 4.3 9.7 5.7 8.3z"></path></svg>';
        },
    },
    watch: {
        /** @type {import('vue').WatchHandler<string>} */
        active() {
            // Make sure menu closes when navigating with nuxt links
            if (this.showMainMenu) {
                this.toggleMainMenu();
            }
        },
    },
    mounted() {
        this.mainContent = !!document.getElementById('main-content');
        this.footerContent = !!document.getElementById('footer-content');
        window.addEventListener('resize', this.checkMainMenu, false);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.checkMainMenu, false);
    },
    methods: {
        /** @param {string} menu */
        subClicker(menu) {
            if (menu !== this.subActive) {
                return;
            }
            this.subclick++;
        },
        /** @param {MouseEvent} event */
        blurButton(event) {
            const button = /** @type {HTMLElement?} */(event.target);
            if (button) {
                button.blur();
            }
        },
        /** @param {string} subActive */
        blurClick(subActive) {
            if (this.debounceTimeout) {
                clearTimeout(this.debounceTimeout);
            }

            this.debounceTimeout = setTimeout(() => {
                this.debounceTimeout = null;
                if (subActive === this.subActive) {
                    this.subclick++;
                    this.subActive = '';
                } else {
                    this.subActive = subActive;
                }
            }, 10);
        },
        /**
         * @param {keyof FALLBACK_TRANSLATIONS} translationKey
         * @return {string}
         */
        getTranslation(translationKey) {
            let translation;

            if (this.translationFn) {
                translation = this.translationFn(translationKey);
            }

            if (!translation && this.translations) {
                translation = this.translations[translationKey];
            }

            const isTranslated = translation && translation !== `webCommon.header.${translationKey}`;
            return isTranslated ? translation : this.fallbackTranslations[translationKey];
        },
        checkMainMenu() {
            // Toggle focus for elements behind the menu
            const menu = /** @type {HTMLDivElement | null} */(this.$refs.menu);
            const isVisible = !!menu && menu.offsetParent !== null;
            this.toggleFocus(isVisible);
        },
        toggleMainMenu() {
            this.showMainMenu = !this.showMainMenu;
            this.subActive = '';

            // Toggle focus for elements behind the menu
            this.toggleFocus(this.showMainMenu);

            if (this.showMainMenu) {
                this.scrollPos = document.documentElement.scrollTop || document.body.scrollTop;
            } else {
                document.documentElement.scrollTop = document.body.scrollTop = this.scrollPos;
            }
        },
        logout() {
            if (this.logoutFunc instanceof Function) {
                this.logoutFunc();
            } else {
                window.location.href = this.logoutUrl || (this.baseUrl + 'logout');
            }
        },
        /** @param {string} elementId */
        focus(elementId) {
            const el = document.getElementById(elementId);
            if (el) {
                el.focus();
            }
        },
        /** @param {boolean} isHidden */
        toggleFocus(isHidden) {
            ['main-content', 'footer-content'].forEach(elementId => {
                const el = document.getElementById(elementId);
                if (el) {
                    if (isHidden) {
                        el.setAttribute('aria-hidden', 'true');
                        el.setAttribute('inert', 'true');
                    } else {
                        el.removeAttribute('aria-hidden');
                        el.removeAttribute('inert');
                    }
                }
            });
        },
    },
};
